<template>
  <section class="credits">
    <div class="container">
      <h1>{{ $t('credits.title') }}</h1>
      <div class="intro" v-html="$t('credits.intro')" />

      <div class="columns">
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/alex.png" />
            </div>
            <div class="member-name">Alexander Camenzind</div>
            <div class="member-role">
              {{ $t('credits.roles.master') }} <br />
              <a
                target="_blank"
                href="https://www.usi.ch/en/education/master/software-and-data-engineering/"
                >MSDE</a
              >
              @ <a target="_blank" href="https://si.usi.ch/">Software Institute</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:camenal@usi.ch"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/alexander-camenzind-421517154"
                  ><font-awesome-icon :icon="['fab', 'linkedin']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/aron.png" />
            </div>
            <div class="member-name">Aron Fiechter</div>
            <div class="member-role">
              {{ $t('credits.roles.master') }} <br />
              <a
                target="_blank"
                href="https://www.usi.ch/en/education/master/software-and-data-engineering/"
                >MSDE</a
              >
              @ <a target="_blank" href="https://si.usi.ch/">Software Institute</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:aron.fiechter@gmail.com"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/aron-fiechter/"
                  ><font-awesome-icon :icon="['fab', 'linkedin']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://twitter.com/AronFiechter"
                  ><font-awesome-icon :icon="['fab', 'twitter']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="http://aron.fiechter.gitlab.io/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/federico.png" />
            </div>
            <div class="member-name">Federico Pfahler</div>
            <div class="member-role">
              {{ $t('credits.roles.master') }} <br />
              <a
                target="_blank"
                href="https://www.usi.ch/en/education/master/software-and-data-engineering/"
                >MSDE</a
              >
              @ <a target="_blank" href="https://si.usi.ch/">Software Institute</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:pfahler.federico@gmail.ch"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/federico-pfahler-923306132/"
                  ><font-awesome-icon :icon="['fab', 'linkedin']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://pfahlf.github.io/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/gustavo.png" />
            </div>
            <div class="member-name">Gustavo Graziani</div>
            <div class="member-role">
              {{ $t('credits.roles.master') }} <br />
              <a
                target="_blank"
                href="https://www.usi.ch/en/education/master/software-and-data-engineering/"
                >MSDE</a
              >
              @ <a target="_blank" href="https://si.usi.ch/">Software Institute</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:gustavo.graziani@outlook..com"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/gustavo-graziani-397665197/"
                  ><font-awesome-icon :icon="['fab', 'linkedin']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://twitter.com/gus_grz"
                  ><font-awesome-icon :icon="['fab', 'twitter']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="http://ggraziani.github.io/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/valerie.png" />
            </div>
            <div class="member-name">Valerie Burgener</div>
            <div class="member-role">
              {{ $t('credits.roles.master') }} <br />
              <a
                target="_blank"
                href="https://www.usi.ch/en/education/master/software-and-data-engineering/"
                >MSDE</a
              >
              @ <a target="_blank" href="https://si.usi.ch/">Software Institute</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:valerie.burgener@usi.ch"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://twitter.com/lazy_val_b"
                  ><font-awesome-icon :icon="['fab', 'twitter']"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-fifth is-offset-1">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/alberto.png" />
            </div>
            <div class="member-name">Alberto Barberis</div>
            <div class="member-role">
              {{ $t('credits.roles.art-teacher') }} <br />
              <a target="_blank" href="https://www.conservatorio.ch/it/scuola-universitaria"
                >Conservatorio della Svizzera italiana</a
              >
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:albertobarberis11@gmail.com"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="http://www.albertobarberis.it/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/rob.png" />
            </div>
            <div class="member-name">Dr. Roberto Minelli</div>
            <div class="member-role">
              {{ $t('credits.roles.pdoc') }} <br />
              <a target="_blank" href="http://reveal.si.usi.ch/">REVEAL</a>
              @ <a target="_blank" href="https://si.usi.ch/">Software Institute</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:roberto.minelli@usi.ch"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/minellir/"
                  ><font-awesome-icon :icon="['fab', 'linkedin']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://twitter.com/robertominelli"
                  ><font-awesome-icon :icon="['fab', 'twitter']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="http://robertominelli.com/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/michele.png" />
            </div>
            <div class="member-name">Prof. Dr. Michele Lanza</div>
            <div class="member-role">
              {{ $t('credits.roles.director') }} @
              <a target="_blank" href="https://si.usi.ch/">Software Institute</a><br />
              &
              {{ $t('credits.roles.head') }}
              <a target="_blank" href="http://reveal.si.usi.ch/">REVEAL</a>
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:michele.lanza@usi.ch"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/michelelanza/"
                  ><font-awesome-icon :icon="['fab', 'linkedin']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://twitter.com/lanzamichele"
                  ><font-awesome-icon :icon="['fab', 'twitter']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.inf.usi.ch/faculty/lanza/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="member-container">
            <div class="pict-container">
              <img class="member-pict" src="@/assets/team/nadir.png" />
            </div>
            <div class="member-name">Prof. Nadir Vassena</div>
            <div class="member-role">
              {{ $t('credits.roles.art-teacher') }} <br />
              <a target="_blank" href="https://www.conservatorio.ch/it/scuola-universitaria"
                >Conservatorio della Svizzera italiana</a
              >
            </div>
            <div class="level is-mobile member-contacts">
              <div class="level-item has-text-centered">
                <a target="_blank" href="mailto:nadir.vassena@conservatorio.ch"
                  ><font-awesome-icon :icon="['far', 'envelope']"
                /></a>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="http://nadirvassena.ch/"
                  ><font-awesome-icon :icon="['fas', 'link']"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="level container foot">
      <div class="level-item has-text-centered">
        <figure class="image logo">
          <a target="_blank" href="http://reveal.si.usi.ch/"
            ><img src="@/assets/logo/logo-REVEAL.png"
          /></a>
        </figure>
      </div>
      <div class="level-item has-text-centered">
        <figure class="image logo">
          <a target="_blank" href="https://si.usi.ch/"
            ><img src="@/assets/logo/logo-usisoftware.png"
          /></a>
        </figure>
      </div>
      <div class="level-item has-text-centered">
        <figure class="image logo">
          <a target="_blank" href="https://www.conservatorio.ch/it/scuola-universitaria"
            ><img src="@/assets/logo/logo-conservatorio.png"
          /></a>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Credits',
  data() {
    return {};
  },
};
</script>

<style scoped>
.credits {
  padding: 2rem 1.5rem;
  min-height: calc(100vh - 3.25rem);
}

.member-name,
.member-role,
.pict-container {
  text-align: center;
}

.member-contacts {
  color: white;
}

.member-pict {
  border-radius: 50%;
  width: 100%;
  max-width: 250px;
}

div.member-contacts {
  max-width: 120px;
  margin: auto;
}

.member-name {
  font-size: 1.1rem;
  font-weight: bold;
}

.member-role {
  font-size: 0.9rem;
}

.intro {
  padding-bottom: 2rem;
}

.foot {
  padding-top: 5rem;
}

div {
  color: white;
  background-color: black;
}

h1 {
  text-decoration: underline;
  font-weight: bold;
  font-size: xx-large;
  margin-bottom: 20px;
}

h2 {
  text-decoration: underline;
  font-weight: bold;
  font-size: x-large;
  margin-bottom: 10px;
  margin-top: 10px;
}

h3 {
  text-decoration: underline;
  font-weight: bold;
  font-size: large;
  margin-bottom: 5px;
  margin-top: 10px;
}

ul > li {
  padding-left: 10px;
  margin: 5px 0px 5px 5px;
}

strong {
  color: white;
}

.logo {
  width: 250px;
}
</style>
